// utils/csrf.ts
import CryptoJS from "crypto-js";

export const getCSRF = async () => {
  const csrfCode = Math.floor(Math.random() * (999999 - 111111 + 1)) + 111111;
  const timestamp = Date.now(); // milliseconds since epoch

  const csrfKey = process.env.CSRF_KEY || "";
  const csrfIv = process.env.CSRF_IV || "";

  const key = CryptoJS.enc.Utf8.parse(csrfKey);
  const iv = CryptoJS.enc.Utf8.parse(csrfIv);

  // pack code + timestamp into one payload, delimiter must not appear in either value
  const payload = `${csrfCode}|${timestamp}`;

  const encrypted = CryptoJS.AES.encrypt(payload, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  const csrfToken = encrypted.ciphertext.toString(CryptoJS.enc.Hex);

  if (
    typeof window !== "undefined" &&
    typeof window.sessionStorage !== "undefined"
  ) {
    sessionStorage.setItem("csrf_code", csrfCode.toString());
    sessionStorage.setItem("csrf_time", timestamp.toString()); // optional, for client-side reference
  }

  return csrfToken;
};
